import type { IconType } from "react-icons";
import { LuDollarSign, LuEuro, LuPoundSterling } from "react-icons/lu";

export const SUPPORTED_CURRENCIES = ["CAD", "USD", "EUR", "GBP"] as const;

export type SupportedCurrency = (typeof SUPPORTED_CURRENCIES)[number];

export const CURRENCY_LABELS: Record<SupportedCurrency, string> = {
  CAD: "Canadian Dollar",
  USD: "US Dollar",
  EUR: "Euro",
  GBP: "British Pound",
};

const CURRENCY_ICON_COMPONENTS: Record<SupportedCurrency, IconType> = {
  CAD: LuDollarSign,
  USD: LuDollarSign,
  EUR: LuEuro,
  GBP: LuPoundSterling,
};

export function CurrencyIcon({ currency, size = 16 }: { currency: string; size?: number }) {
  const Icon = CURRENCY_ICON_COMPONENTS[currency as SupportedCurrency];
  return Icon ? <Icon size={size} /> : null;
}

export const CURRENCY_ICONS: Record<string, React.ReactNode> = Object.fromEntries(
  SUPPORTED_CURRENCIES.map((currency) => [
    currency,
    <CurrencyIcon key={currency} currency={currency} />,
  ]),
);
